import React from 'react'
import { Box, Container, Grid, Link, Typography } from '@mui/material';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import Instagram from '@mui/icons-material/Instagram';
import { APP_URL } from '../../Config';
import notrevealed from "../../images/notrevealed.jpg";

const Buyright = (props) => {
       
    return (
        <>
            <Box className='Collection_auction' paddingY={1}>
                <Container maxWidth='xl'>
                    <Grid container spacing={2} className='quidam'>
                        <Grid  item xs={12} md={12} >
                            <Box className='mainsboxs' >
                                <Box className='innerimg'>
                                {props.buyprop?.data?.NFT_info?.NFT_image.split('.').pop()== "png" ||props.buyprop?.data?.NFT_info?.NFT_image.split('.').pop()=='jpg'||props.buyprop?.data?.NFT_info?.NFT_image.split('.').pop()=='jpeg'?
                                    <img src={props.buyprop?.data?.NFT_info?.Private==0?APP_URL+'/'+props.buyprop?.data?.NFT_info?.NFT_image:notrevealed} width='100%'  /> 
                                    :props.buyprop?.data?.NFT_info?.NFT_image.split('.').pop()== "mp4" ?
                                    <video width="750" height="500" controls >
                                        <source src={props.buyprop?.data?.NFT_info?.Private==0?APP_URL+'/'+props.buyprop?.data?.NFT_info?.NFT_image:notrevealed} type="video/mp4"/>
                                    </video>
                                    :props.buyprop?.data?.NFT_info?.NFT_image.split('.').pop()== "mp3" ||props.buyprop?.data?.NFT_info?.NFT_image.split('.').pop()=='aac'?
                                    <audio controls>
                                    <source src={props.buyprop?.data?.NFT_info?.Private==0?APP_URL+'/'+props.buyprop?.data?.NFT_info?.NFT_image:notrevealed} type="audio/mpeg"/>
                                    Your browser does not support the audio tag.
                                    </audio> 
                                    :<img src={props.buyprop?.data?.NFT_info?.Private==0?APP_URL+'/'+props.buyprop?.data?.NFT_info?.NFT_image:notrevealed} width='100%'  />
                                    } 
                                    {/* <img src={APP_URL+'/'+props.buyprop?.data?.NFT_info?.NFT_image} width='100%' /> */}
                                </Box>
                                <Box className='social_links' textAlign='center'>
                                    <Link href={`https://twitter.com/intent/tweet?url=${APP_URL}/Buydetails/${props.buyprop?.data?.NFT_info?.NFT_id}`} color='#fff' target="blank"> <TwitterIcon className='ico' /> </Link>
                                    <Link href={`https://www.facebook.com/sharer/sharer.php?u=${APP_URL}/Buydetails/${props.buyprop?.data?.NFT_info?.NFT_id}`}  target="blank" color='#fff'> <FacebookIcon className='ico' />  </Link>
                                    <Link href={`https://www.instagram.com/?url=${APP_URL}/Buydetails/${props.buyprop?.data?.NFT_info?.NFT_id}`} color='#fff' target="blank" >  <Instagram className='ico' /> </Link>
                                </Box>
                            </Box>
                            </Grid>
                    </Grid>
                </Container>
            </Box>
        </>
    )
}

export default Buyright;

